import { render } from "./Popup.vue?vue&type=template&id=6ed14f20&scoped=true"
import script from "./Popup.vue?vue&type=script&lang=js"
export * from "./Popup.vue?vue&type=script&lang=js"

import "./Popup.vue?vue&type=style&index=0&id=6ed14f20&scoped=true&lang=css"

import exportComponent from "D:\\Project\\远创人力\\开发\\前端\\yc_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed14f20"]])

export default __exports__